console.log('Custom JS');
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
var color = urlParams.get('color');
console.log(color);
if(color){
  color = color.toLowerCase();
  $('.thumbnail-swatch.value-'+color).click();
}
function waitForElement(selector, callback, interval = 100, timeout = 5000) {
  let timer = setInterval(() => {
    if ($(selector).length) {
      clearInterval(timer);
      callback($(selector));
    }
  }, interval);

  setTimeout(() => {
    if (timer) {
      clearInterval(timer);
      console.warn(`Timeout: Element "${selector}" not found.`);
    }
  }, timeout);
}

// Example usage:
waitForElement('.w3-product-options.loaded', function($element) {
    console.log('Element found:', $element);
});

function formatMoneyPrice(price) {
// Convert price to number and format
const numPrice = parseFloat(price / 100)
return numPrice.toFixed(2)
}
